module.exports = __webpack_public_path__ + "static/media/fruits_1.8833c9f1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_1.csv
// module id = 673
// module chunks = 0